import { UserRoleEnum } from "enums/user-role.enum";

export const UserRoleLabel: Record<UserRoleEnum, string> = {
  [UserRoleEnum.ADMIN]: "ADMIN",
  [UserRoleEnum.LEADER]: "LEADER",
  [UserRoleEnum.AGENT]: "AGENT",
};
